import { STORAGE_KEYS as t } from "./storage-manager.js";
export function getAlias(e) {
  const n = null == e ? void 0 : e.ps(t.bs.SE);
  let o;
  return n && (o = { label: n.l, name: n.a }), o;
}
